"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function useGatsbyImage(src, options) {
  return (0, _react.useMemo)(function () {
    var childImageSharp = {};
    if (!src) return {
      localFile: null,
      url: src
    };
    var extMatch = src.match(/\.(\w+)(?:\?|$)/);
    var extension = extMatch === null || extMatch === void 0 ? void 0 : extMatch[1];

    if (extension === 'svg') {
      return {
        localFile: {
          childImageSharp: null,
          publicURL: src
        },
        url: src
      };
    }

    switch (options.type) {
      case 'fixed':
        if (!options.width || !options.height) {
          throw Error("useGatsbyImage: The type fixed requires 'width' and 'height'.");
        }

        childImageSharp = {
          fixed: {
            width: options.width,
            height: options.height,
            src: src,
            srcSet: src
          }
        };
        break;

      case 'fluid':
        if (!options.aspectRatio || !options.maxWidth) {
          throw Error("useGatsbyImage: The type fluid requires 'aspectRatio' and 'sizes'.");
        }

        childImageSharp = {
          fluid: {
            aspectRatio: options.aspectRatio,
            src: src,
            srcSet: src,
            sizes: "(max-width: ".concat(options.maxWidth, "px) 100vw, ").concat(options.maxWidth, "px")
          }
        };
        break;

      default:
        throw Error("useGatsbyImage: The type ".concat(options.type, " is not supported. Use 'fixed' or 'fluid' instead!"));
    }

    return {
      localFile: {
        publicURL: src,
        childImageSharp: childImageSharp
      },
      url: src
    };
  }, [src, options.type, options.width, options.height, options.aspectRatio, options.maxWidth]);
}

var _default = useGatsbyImage;
exports["default"] = _default;